
import React from 'react';
import { Search, PawPrint } from 'lucide-react';

interface TourSearchProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  filteredToursCount: number;
  totalToursCount: number;
  resetSearch: () => void;
}

const TourSearch: React.FC<TourSearchProps> = ({ 
  searchQuery, 
  setSearchQuery, 
  filteredToursCount, 
  totalToursCount,
  resetSearch
}) => {
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  };

  return (
    <div className="max-w-xl mx-auto mb-12">
      <div className="relative">
        <label htmlFor="tour-search" className="sr-only">Search tours</label>
        <input
          id="tour-search"
          type="search"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search our tours..."
          className="w-full border border-gray-300 rounded-lg px-4 py-3 pr-12 focus:outline-none focus:ring-2 focus:ring-[#C46829] focus:border-[#C46829]"
          aria-label="Search tours"
        />
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
          <Search className="h-5 w-5" aria-hidden="true" />
        </div>
      </div>
      
      {searchQuery && (
        <div className="mt-2 text-sm" aria-live="polite">
          {filteredToursCount === 0 ? (
            <p className="text-gray-500">No tours found matching "{searchQuery}"</p>
          ) : (
            <p className="text-gray-600">Found {filteredToursCount} tour{filteredToursCount !== 1 ? 's' : ''} matching "{searchQuery}"</p>
          )}
        </div>
      )}

      {filteredToursCount === 0 && (
        <div className="py-12 text-center">
          <div className="flex justify-center mb-4">
            <PawPrint size={48} className="text-[#C46829] opacity-50" aria-hidden="true" />
          </div>
          <h2 className="text-xl font-medium mb-2">No tours found</h2>
          <p className="text-gray-600 mb-6">Try adjusting your search or browse all tours.</p>
          <button 
            onClick={resetSearch}
            className="px-6 py-2 bg-[#C46829] text-white rounded-md hover:bg-[#B35718] transition-colors"
          >
            View all tours
          </button>
        </div>
      )}
    </div>
  );
};

export default TourSearch;
